import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const EarlySubscriberForm: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900">
      {/* Header Section */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-r from-purple-600 to-blue-600 rounded-xl flex items-center justify-center">
              <img src="/images/G_white.svg" alt="Gyaanly" className="w-10 h-10" />
              </div>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              Register for Early Access
            </h1>
            <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
              Start your journey as a learner or creator. Fill out the form below to get early access to our platform.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Google Form Section */}
      <section className="py-20 bg-white/5 backdrop-blur-sm">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true, amount: 0.2 }}
            className="glass-card p-8 border border-white/20"
          >
            <div className="relative w-full" style={{ height: '800px' }}>
              <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLSdvVzH8IFobenPvw8Rowo8kshuFJNG0t8_fS3xlSWlwL8b52g/viewform?embedded=true"
                width="100%"
                height="100%"
                frameBorder="0"
                marginHeight={0}
                marginWidth={0}
                title="Gyaanly Registration Form"
                className="rounded-lg"
              >
                Loading…
              </iframe>
            </div>
          </motion.div>

          {/* Additional Information */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true, amount: 0.2 }}
            className="text-center mt-12"
          >
            <div className="grid md:grid-cols-3 gap-8">
              <div className="glass-card p-6 text-center">
                <div className="w-12 h-12 bg-purple-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🎯</span>
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">Early Access</h3>
                <p className="text-gray-300 text-sm">
                  Be among the first to experience Gyaanly's innovative platform
                </p>
              </div>
              <div className="glass-card p-6 text-center">
                <div className="w-12 h-12 bg-blue-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">💡</span>
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">Personalized Setup</h3>
                <p className="text-gray-300 text-sm">
                  Get recommendations tailored to your specific goals and expertise
                </p>
              </div>
              <div className="glass-card p-6 text-center">
                <div className="w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🚀</span>
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">Priority Support</h3>
                <p className="text-gray-300 text-sm">
                  Receive dedicated support as an early adopter of our platform
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true, amount: 0.2 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Ready to Get Started?
            </h2>
            <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
              After submitting the form, we'll reach out to you with next steps and exclusive early access benefits.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default EarlySubscriberForm;